import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { useHasPermission } from "shared/utils/PermissionUtils";

export interface RestrictedProps {
  permission: PermissionTypeEnum;
}

export const Restricted: React.FC<React.PropsWithChildren<RestrictedProps>> = ({
  permission,
  children,
}) => {
  const hasPermission = useHasPermission(permission);
  return hasPermission ? children : null;
};
